<section class="map-container">
    <div class="map-frame">
        <div id="map"></div>
        <kp-map-controls
            [map]="map"
            [isEditable]="isEditable"
            [isEditing]="isEditing"
            (toggleEditing)="toggleEditing()"
            (resetZoom)="resetZoom()"
            (selectFeature)="selectFeature()"
            (uploadImg)="addCoordinatesToImage($event)"
            (save)="saveChanges()"
            (cancel)="cancelChanges()"
        ></kp-map-controls>
        <kp-map-features
            [data]="data"
            [map]="map"
            [isEditing]="isEditing"
            [layersControl]="layersControl"
            (editImage)="editFeature($event)"
            (featureClicked)="featureClicked.emit($event)"
            (mutation)="mutate($event)"
            [showSearch]="!isFleetTab"
        ></kp-map-features>
        <kp-map-feature-editor
            *ngIf="editingFeature"
            [feature]="editingFeature"
            (uploadImg)="setImage($event, editingFeature)"
            (mutation)="mutateFeature($event)"
            (remove)="requestRemoveFeature($event)"
            (ok)="endEditFeature()"
            (cancel)="endEditFeature()"
        ></kp-map-feature-editor>
        <kp-map-select-feature
            *ngIf="selectingFeature"
            [data]="data"
            (close)="closeSelectFeature()"
            (select)="placeFeature($event)"
        ></kp-map-select-feature>
    </div>
</section>
